import * as React from 'react'

import { GridItem, Grid } from '@thg-commerce/gravity-system'
import { styled, Text, mq, spacing } from '@thg-commerce/enterprise-theme'
import { ImageProps } from '@thg-commerce/gravity-elements/Image/Image'
import { LinkCard } from '@thg-commerce/gravity-elements/LinkCard/LinkCard'

export interface GlobalLinkCardsProps {
  heading?: string
  displayMode?: 'plain' | 'background'
  items: {
    image: Omit<ImageProps, 'isAmp'>
    name: string
    link: string
  }[]
  isAmp: boolean
}

const Title = styled.h3`
  ${Text('large1', 'alternate')}

  text-align: center;
`

const TitleGridItem = styled(GridItem)`
  margin-bottom: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(4)};
  }
`

const StyledGrid = styled(Grid)`
  margin: 0;
`

const LinkGridItem = styled(GridItem)`
  margin-bottom: ${spacing(4)};
`

export const GlobalLinkCards = React.memo(
  ({ items, heading, displayMode, isAmp }: GlobalLinkCardsProps) => {
    const gridItemColSpan = [12, 6, 3, 3]

    const totalColumns = 12
    const gridItemRowOffset = 2
    const shopLinks = items.map((item, index) => {
      const colStart = gridItemColSpan.map(
        (colSpan) => (index % (totalColumns / colSpan)) * colSpan + 1,
      )
      const rowStart = gridItemColSpan.map((colSpan) =>
        Math.floor(index / (totalColumns / colSpan) + gridItemRowOffset),
      )

      return (
        <LinkGridItem
          colSpan={gridItemColSpan}
          colStart={colStart}
          rowStart={rowStart}
          key={`global-link-card-${index}`}
        >
          <LinkCard {...item} isAmp={isAmp} displayMode={displayMode} />
        </LinkGridItem>
      )
    })

    return (
      <StyledGrid>
        <TitleGridItem colSpan={12} colStart={1} rowStart={1}>
          <Title>{heading}</Title>
        </TitleGridItem>
        {shopLinks}
      </StyledGrid>
    )
  },
)
